import { TOption } from './types';

export const getJoinedString = (join: { [key: string]: string }) => {
  return Object.keys(join)
    .filter((key) => key.includes('.label'))
    .reverse()
    .map((key) => join[key])
    .join(' / ');
};

export const filterJoins = (data: Array<{ [key: string]: string }>, value: string) => {
  return data.filter((join) => {
    const keys = Object.keys(join);
    const filteredKeys = keys.filter((key) => key.includes('.label'));
    let include = false;
    for (const key of filteredKeys) {
      if (join[key].toLowerCase().includes(value.toLowerCase())) {
        include = true;
      }
    }
    return include;
  });
};

export const processJoinsToOptions = (data: Array<{ [key: string]: string }>): TOption[] => {
  return data.map((join) => {
    return {
      label: getJoinedString(join),
      value: JSON.stringify(join),
    };
  });
};

export const calculateCommercialSpeed = (totalPassingValue: number, rigOperationsDrillingDuration: number): number => {
  return Math.round(((totalPassingValue * 100) / (rigOperationsDrillingDuration * 100)) * 30.4 * 100) / 100;
};

export const calculateDurationByCommercialSpeed = (passingValue: number, commercialSpeed: number): number => {
  return Math.round((passingValue * 10000) / (commercialSpeed / 30.4)) / 10000;
};
